import api from 'networkapp-api-connector';
import moment from 'moment';

export default {
    fetchActiveSessions() {
        return api.chat.fetchActiveSessions().then((data) => {
            app.store.dispatch(app.actions.chat.updateActiveSessions(data.result, moment.utc(data.fetch_time).toISOString()));
            return data.result;
        });
    },
    fetchMessages: function (chatId) {
        if (!chatId) return Promise.resolve();

        return (
            api.chat
                .fetchMessages(chatId)
                .then((data) => {
                    app.store.dispatch(app.actions.chat.updateMessages(chatId, data.messages));
                })
        );
    },
    postMessage: function (message, partnerId, eventId) {
        return api.chat.postMessage(message, partnerId, eventId).then((data) => {
            app.store.dispatch(app.actions.chat.updateMessages(data.chatId, [data]));
            return data;
        });
    },
    markAllAsRead: function (chatId) {
        return api.chat.markAllAsRead(chatId).then((data) => {
            app.store.dispatch(app.actions.chat.markAllAsRead(chatId));
        });
    },
};
